import styled from "styled-components";

export const StyledEmpty = styled.div`
  width: 100%;
  flex: 1;
  min-height: 280px;
  padding: 48px 24px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  img {
    width: 120px;
  }
`;
